const cards = [
  {
    title: '流浪地球3：人类命运的最后抉择',
    desc: '太阳即将毁灭，人类面临前所未有的生存危机，一场跨越星际的壮丽远征就此展开。顶级特效打造史诗级科幻巨制。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20massive%20spaceship%20fleet%20approaching%20a%20distant%20planet%2C%20dramatic%20warm%20golden%20light%2C%20cinematic%20composition%2C%20grand%20scale%20with%20stars%20and%20nebula%20background%2C%20movie%20poster%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '科幻巨制',
    rating: '9.2',
    type: '电影',
  },
  {
    title: '长安十二时辰：盛世暗流',
    desc: '天宝三载，上元节前夕，长安城暗流涌动。死囚张小敬临危受命，十二时辰之内必须揭开惊天阴谋。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20during%20lantern%20festival%2C%20traditional%20architecture%20with%20warm%20golden%20lanterns%2C%20dramatic%20mysterious%20atmosphere%2C%20Tang%20dynasty%20aesthetic%2C%20cinematic%20composition&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '古装悬疑',
    rating: '8.9',
    type: '电视剧',
  },
  {
    title: '繁花：九十年代上海风云',
    desc: '阿宝从一个普通青年成长为商界大亨，在九十年代上海滩谱写了一段跌宕起伏的传奇人生。',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20at%20night%20with%20neon%20lights%20and%20busy%20streets%2C%20nostalgic%20warm%20golden%20tone%2C%20Chinese%20modern%20drama%20aesthetic%2C%20cinematic%20composition%20with%20retro%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '都市情感',
    rating: '9.0',
    type: '电视剧',
  },
  {
    title: '名侦探柯南：百万美元的五棱星',
    desc: '怪盗基德发出预告，目标锁定北海道函馆的传奇宝物。柯南与基德宿命对决再度上演。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20Japanese%20night%20scene%20with%20full%20moon%20and%20city%20silhouette%2C%20dramatic%20shadows%20and%20warm%20amber%20lighting%2C%20anime%20movie%20poster%20aesthetic%2C%20mystery%20and%20suspense%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '经典动漫',
    rating: '8.7',
    type: '动漫',
  },
  {
    title: '大江大河3：时代的弄潮儿',
    desc: '宋运辉、雷东宝、杨巡三人在改革开放大潮中各奔前程，见证了中国经济腾飞的壮阔历程。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20industrial%20cityscape%20with%20factories%20and%20river%2C%20warm%20sunset%20golden%20light%2C%20dramatic%20sky%20and%20reflections%2C%20Chinese%20historical%20drama%20aesthetic%2C%20epic%20scale&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '年代剧',
    rating: '9.1',
    type: '电视剧',
  },
  {
    title: '乘风破浪的姐姐：舞台上的光芒',
    desc: '三十位姐姐重新出发，用汗水和实力证明自己。每一个高光舞台背后都是不为人知的付出。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20with%20spotlights%20and%20colorful%20lighting%20effects%2C%20energetic%20concert%20atmosphere%2C%20music%20performance%20with%20warm%20golden%20and%20pink%20tones%2C%20variety%20show%20aesthetic&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '热门综艺',
    rating: '8.5',
    type: '综艺',
  },
  {
    title: '地球脉动3：生命的奇迹',
    desc: '大卫·爱登堡爵士再度带领观众穿越全球，探访地球上最震撼人心的自然奇观和野生动物。',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20wildlife%20landscape%20with%20mountains%20and%20golden%20sunrise%20light%2C%20diverse%20animals%20in%20natural%20habitat%2C%20nature%20documentary%20aesthetic%2C%20epic%20scale%20and%20vibrant%20colors%2C%20cinematic%20wide%20shot&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '4K纪录',
    rating: '9.5',
    type: '纪录片',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选推荐</h2>
            <p className="mt-3 text-sm text-foreground-500">编辑精选 · 品质保证</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cards.map((card) => (
              <div key={card.title} className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1">
                <div className="relative overflow-hidden aspect-[3/2]">
                  <img src={card.image} alt={card.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute top-3 left-3 flex items-center gap-2">
                    <span className="px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-900 text-xs font-medium backdrop-blur-sm">
                      {card.tag}
                    </span>
                    <span className="px-2 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-bold backdrop-blur-sm">
                      {card.type}
                    </span>
                  </div>
                  <div className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-1 rounded-md bg-foreground-900/60 text-background-50 text-xs backdrop-blur-sm">
                    <i className="ri-star-fill text-primary-400 text-xs"></i>
                    <span>{card.rating}</span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 leading-snug">{card.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}